var audioCallbacks = {};
let appParams = FAPI.Util.getRequestParameters();
let PLAY_BLANK_AUDIO = false;
const DO_NOT_CHECK_VOTED = false;
const DATE = (d => d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2))(new Date());

try {
  window.LS = localStorage;
} catch(e) {
  window.LS = {
    getItem: () => {}
  };
}

class Audio {
  constructor() {
    this.player = document.getElementById('audio');
    this.isPlaying = false;
    this.currentTrackID = undefined;
    this.clientPhrase = 'secret';
    this.clientVector = [ 6,7,4,7,5,7,8,6,9,1,8,7,8,1,9,8,3,7,1,3,5,2,2,7,2,9,8,1,5,7,9,1 ];
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  buildHash(_md5) {
    var md5Key = _md5 + this.clientPhrase;
    var md5Str = md5(md5Key);

    var sum = 0; // сумма всех 32 чисел
    var l = md5Str.length;

    for (var i = 0; i < l; i++)
        {
      sum += parseInt('0' + md5Str[i], 16);
    }

    var output = '';
    var b; // Соседняя справа цифра, если она последняя, то берётся такаяже
    var num; // Само число
    l = md5Str.length;
    for (let i = 0; i < l; i++)
        {
      num = parseInt('0' + md5Str[i], 16);
      b = ((i + 1) == l) ? num : parseInt('0' + md5Str[i + 1], 16);
      output += Math.abs(sum - (b * num * this.clientVector[i]));
    }

    return output;
  }

  play(trackId) {
    let self = this;
    if (PLAY_BLANK_AUDIO) {
      self.player.play();
      PLAY_BLANK_AUDIO = false;
    }
    if (self.currentTrackID == trackId) {
      self.player.play();
      self.isPlaying = true;
      return;
    }
    self.currentTrackID = trackId;

    let url = `https://wmf.ok.ru/play?session_key=${appParams.session_key}&client=ok_internal_app_1269426432&tid=${trackId}&ctx=pop&jsonp=`;
    (function (url) {
      var elem = document.createElement('script');
      elem.src = url + 'audioCallbacks.func';
      audioCallbacks.func = (data) => {
        let src = data.play;
        let _md5 = self.getParameterByName('md5', src);
        src += `&client=ok_internal_app_1269426432&clientHash=${self.buildHash(_md5)}`;

        if (self.player.src != src) {
          self.player.src = src;
          self.player.play();
        }
        self.isPlaying = true;
      };
      document.head.appendChild(elem);
    })(url);
  }

  pause() {
    this.player.pause();
    this.isPlaying = false;
  }

  getProgress() {
    let val = this.isPlaying && 100 * this.player.currentTime / this.player.duration || 0;
    return Math.round(val);
  }

  setProgress(percent) {
    this.player.currentTime = this.player.duration * percent;
  }
}

let _audio = new Audio();

let _selected = [];

const getRandomInt = (min, max) =>  Math.floor(Math.random() * (max - min)) + min;

const getUserId = () => {
  let userId = appParams.logged_user_id;
  if (userId) {
    return userId;
  }
  const time = (new Date()).getTime();
  const randomInt = getRandomInt(0, 10000);
  userId = window.LS.getItem('userId');
  userId = userId ? userId : `generated${randomInt}${time}`;
  window.LS['userId'] = userId;
  return userId;
};

const checkVoted = () => {
  if (DO_NOT_CHECK_VOTED) {
    return false;
  }
  let user_id = getUserId(0,9);
  let voteRef = db.ref(`/votes/${user_id}/${DATE}/`);

  let value = window.LS.getItem(`_selected-${DATE}`);
  value = value ? JSON.parse(value) : '';

  if (value && typeof value === 'object' && value.length > 0) {
    _selected = value;
    app.showScreen('scr_result');
    return true;
  }

  voteRef.once('value', function(snap) {
    let value = snap.val();
    if (value) {
      _selected = value;
      app.showScreen('scr_result');
    } else {
        app.showScreen('scr_intro');
    }
  });
};

const doVote = (artistLists) => {
  let user_id = getUserId();
  let voteRef = db.ref(`/votes/${user_id}/${DATE}/`);
  voteRef.set(_selected);
  window.LS[`_selected-${DATE}`] = JSON.stringify(_selected);

  for (let artistID of _selected) {
    db.ref(`/artists/${artistID}/votes/${user_id}/${DATE}`).set(true);
    db.ref(`/counters/${artistID}/`).transaction(function(artist) {
      artist = artist || {};
      artist.votesCount = artist.votesCount || 0;
      artist.votesCount++;
      return artist;
    });
  }
  artistLists.map(artists => artists.updateRating());
};

class Artists {

  constructor(artists, groupId) {
    this.artists = artists || [];
    this.groupId = groupId;
    this.selectedArtists = undefined;
    this.currentArtistID = undefined;
    this.audio = _audio;
    this.attachAudioEvents();
    this.searchPhrase = '';
    this.db = db;
    this.user_id = getUserId();
  }

  attachAudioEvents () {
    let self = this;
    self.audio.player.addEventListener('timeupdate', () => $$('[data-progress-bar=\'' + self.currentArtistID + '\'] div').map(elem => elem.dataset.progress = self.audio.getProgress() ));
    self.audio.player.addEventListener('loadstart', () => $$('[data-progress-bar] div').map(elem => elem.dataset.progress = 0 ));
    self.audio.player.addEventListener('ended', () => {
      let artist = self.get(self.currentArtistID);
      if (artist.currIndex == artist.audioList.length - 1) {
        self.pause(self.currentArtistID);
      } else {
        self.next(self.currentArtistID);
      }
    });
    self.audio.player.addEventListener('playing', () => self.renderEqualizer() );

  }

  get(artistID) {
    return this.artists.filter(elem => elem.id == artistID)[0];
  }

  isSelected(artistID) {
    return this.selectedArtists == artistID;
  }

  updatePercents() {
    let self = this;
    let sum = self.artists.map(a => a.rating || 0).reduce((a, b) => (a + b), 0) || 1;
    self.artists.map(artist => artist.percent = Math.round(100 * artist.rating / sum));
  }

  updateRating() {
    let self = this;
    db.ref('/counters/').once('value', snap => {
      let rating = snap.val();
      for (let i in rating) {
        let elem = self.get(i);
        if (elem) {
          elem.rating = rating[i].votesCount;
        }
      }
      self.updatePercents();
      self.renderResults();
      show($$(`[data-rating-list]`));
      hide($$(`[data-loader]`));
    });
  }

  select(artistID) {
    this.selectedArtists = artistID;
    _selected.push(this.selectedArtists);
    removeClass($$('.question .btn'), 'btn-disabled');
  }

  deselect(artistID) {
    this.selectedArtists = undefined;
    _selected = _selected.filter(elem => elem != artistID);
    addClass($$('.question .btn'), 'btn-disabled');
  }

  renderEqualizer() {
        // let self = this;
        // const ra = (min, max) => {return Math.random() * (max - min) + min;};
        // $$(`[data-canvas='${self.currentArtistID}']`).map(canvas => {
        //     canvas.width = canvas.height = 4 * canvas.offsetHeight;
        //     let ctx = canvas.getContext("2d");
        //     ctx.fillStyle = "#ffffff";
        //     let eq = [ra(0.5, 0.35), ra(0.5, 0.45), ra(0.5, 0.35), ra(0.5, 0.2)];
        //     let paddingLeft = canvas.height * 22 / 80 ;
        //     let paddingBottom = canvas.height * 22 / 80 ;
        //     let innerMargin = canvas.height *  4 / 80;
        //     let width = canvas.height * 6 / 80;
        //     let borderRadius = canvas.height * 2 / 80;
        //     let minHeight = 0.5 * (canvas.height - 2 * paddingBottom);
        //     for (var s = 0; 4 > s; s++) {
        //         var r = minHeight + eq[s] * (canvas.height - 2 * paddingBottom);
        //         roundRect(ctx, paddingLeft + (innerMargin + width) * s, canvas.height - r - paddingBottom, width, r, borderRadius, true);
        //     }
        // });
        // if (self.audio.isPlaying) {
        //     self.equalizerTimeout = setTimeout(() => {
        //         clearTimeout(self.equalizerTimeout);
        //         self.renderEqualizer();
        //     }, 140);
        // }
  }

  renderArtists() {
    $$('.js-artist[data-artist-id][data-group-id=\'' + this.groupId + '\']').map(elem => {
      const wrapElement = elem.parentNode.parentNode;
      this.isSelected(elem.dataset.artistId) ? addClass(wrapElement, 'active') : removeClass(wrapElement, 'active');
      !this.isSelected(elem.dataset.artistId) && this.selectedArtists ? addClass(wrapElement, 'inactive') : removeClass(wrapElement, 'inactive');
    });
  }

  renderResults() {
    let self = this;
    self.artists.sort((a, b) => {return (b.rating || 0)- (a.rating || 0);} );
    self.artists.map((artist, index) => artist.order = index);
    self.artists.map(
      artist => $$('.js-result-artist[data-artist-id=\'' + artist.id + '\'][data-group-id=\'' + this.groupId + '\']').map(elem => {
        elem.style.order = artist.order + 1;
        elem.dataset.order = artist.order + 1;
        Array.from(elem.querySelectorAll('.js-votes')).map(_elem => _elem.innerHTML = (artist.percent || '0') + '%');
        // let modulo = (artist.percent || 0) % 10;
        // let votesText;
        // switch (modulo) {
        // case 1:
        //   votesText = 'голос';
        //   break;
        // case 2,3,4:
        //   votesText = 'голоса';
        //   break;
        // default :
        //   votesText = 'голосов';
        //   break;
        // }
        // Array.from(elem.querySelectorAll('.js-votes-text')).map(_elem => _elem.innerHTML = votesText );
      })
    );
  }

  selectArtist(artistId) {
    let self = this;
    self.isSelected(artistId) ? self.deselect(artistId) : self.select(artistId);
    self.render();
  }

  attachUIEvents() {
    let self = this;
    $$('.js-player').map((elem) => elem.addEventListener('click', event => {
      event.stopPropagation();
      return false;
    }));
    $$('.js-artist[data-artist-id][data-group-id=\'' + this.groupId + '\']').map((elem) => elem.addEventListener('click', () => self.selectArtist(elem.dataset.artistId)));
    $$('.koza').map((elem) => elem.addEventListener('click', () => {
      self.selectArtist(elem.parentNode.querySelector('.js-artist').dataset.artistId);
    }));
    // $('[data-send-present]').addEventListener('click', function(e){
    //   e.preventDefault();
    //   this.disabled = true;
    //   this.innerHTML = this.value = 'Значок прикреплен';
    // });
  }

  attachEvents(prefix='') {
    let self = this;
    $$(`${prefix} [data-prev]`).map((elem) => elem.addEventListener('click', () => self.prev(elem.dataset.prev)));
    $$(`${prefix} [data-next]`).map((elem) => elem.addEventListener('click', () => self.next(elem.dataset.next)));
    $$(`${prefix} [data-play]`).map((elem) => elem.addEventListener('click', () => self.play(elem.dataset.play)));
    $$(`${prefix} [data-pause]`).map((elem) => elem.addEventListener('click', () => self.pause(elem.dataset.pause)));
    $$(`${prefix} [data-progress-bar]`).map((elem) => elem.addEventListener('click', event => {
      event.stopPropagation();
      let percent = (event.clientX - elem.offsetParent.offsetLeft) / elem.offsetWidth;
      self.progress(elem.dataset.progressBar, percent);
    }));
  }

  changeIndex(artist, plus=0) {
    artist.currIndex = artist.currIndex || 0;
    artist.currIndex += plus;
    if (artist.currIndex < 0) {
      artist.currIndex += artist.audioList.length;
    }
    artist.currIndex = artist.currIndex % artist.audioList.length;
    let track = artist.audioList[artist.currIndex];
    $$('[data-artist-id=\'' + artist.id + '\'] [data-audio-title]').map(elem => elem.innerHTML = track.title);
  }

  play(artistID) {
    this.currentArtistID && this.currentArtistID != artistID && $('[data-pause=\'' + this.currentArtistID + '\']').click();

    hide($$(`[data-play='${artistID}']`));
    show($$(`[data-pause='${artistID}']`));
    addClass($$(`[data-progress-bar='${artistID}']`), 'active');
    addClass($$(`[data-search] [data-artist-id='${artistID}']`), 'playing');
        // show($$(`[data-canvas='${artistID}']`));

    this.currentArtistID = artistID;
    let artist = this.get(artistID);

    this.changeIndex(artist);

    let track = artist.audioList[artist.currIndex];
    this.audio.play(track.trackId);
  }

  pause(artistID) {
    this.audio.pause();
    hide($$(`[data-pause='${artistID}']`));
    show($$(`[data-play='${artistID}']`));
    removeClass($$(`[data-progress-bar='${artistID}']`), 'active');
    removeClass($$(`[data-search] [data-artist-id='${artistID}']`), 'playing');
        // hide($$("[data-canvas]"));
  }

  next(artistID) {
    let artist = this.get(artistID);
    if (this.audio.isPlaying && this.currentArtistID != artistID) {
      return this.play(artistID);
    }
    this.changeIndex(artist, 1);
    this.audio.isPlaying && this.play(artistID);
  }

  prev(artistID) {
    if (this.audio.isPlaying && this.currentArtistID != artistID) {
      return this.play(artistID);
    }
    let artist = this.get(artistID);
    this.changeIndex(artist, -1);
    this.audio.isPlaying && this.play(artistID);
  }

  progress(artistID, percent) {
    this.audio.setProgress(percent);
  }

  render() {
    this.renderResults();
    this.renderArtists();
  }
}

var artistLists = [];
window._data.artistLists.map(artistList => {
  let artists = new Artists(artistList.list, artistList.groupId);
  artists.updateRating();
  artistLists.push(artists);
});

window.addEventListener('load', () => {
  app.start();
  checkVoted();

  artistLists.map(artists => {
    artists.render();
    artists.attachUIEvents();
    artists.attachEvents();
  });
  $('[data-vote]').addEventListener('click', () => doVote(artistLists));
});


(function checkingAutoplay() {
  var
        /** @type {Promise} */
        result;

  let artists = artistLists[0];
  result = artists.audio.player.play();
  if (result) {
    result.then(function() {
      artists.audio.player.pause();
    }, function() {
      PLAY_BLANK_AUDIO = true;
            // window.addEventListener("click", cheatSafari);
    });
  } else {
        /* Что-то неправильное */
    artists.audio.player.pause();
  }

}());

// eslint-disable-next-line no-unused-vars
const correctVotesCount = () => {
  db.ref('/counters/').once('value', v => {
    let a = v.val();
    for (let i in a) {
      db.ref(`/artists/${i}/votes/`).once('value', snap => {
        let votesCount = snap.numChildren();
        db.ref(`/counters/${i}/`).transaction(artist => {
          artist = artist || {};
          artist.votesCount = votesCount;
          return artist;
        });
      });
    }
  });
};
